import React from "react";
import { makeStyles } from "@mui/styles";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import { Chip } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { getGlobalCriticalContext } from "../../../utils/getCriticalContext";
import { useTranslation } from "react-i18next";
import { translate } from "../../../utils/utils";

export default function RiskCard({ risk }) {
  const { t } = useTranslation();
  const lang = localStorage.getItem("i18nextLng");
  const criticalContext = getGlobalCriticalContext(risk?.risk_value);
  const useStyles = makeStyles({
    root: {
      cursor: "pointer",
      padding: "20px",
      borderLeft: `6px solid ${criticalContext?.colorCode}`,
    },
  });
  const classes = useStyles();
  const getColor = () => {
    return criticalContext?.color || "neutral";
  };

  return (
    <Card className={classes.root}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          <Typography variant="body3">
            {risk?.[translate("title")] || t("not_specified")}
          </Typography>{" "}
          <Typography variant="body3">Source: {risk?.source}</Typography>{" "}
        </div>
        {lang === "en" ? (
          <Chip
            label={`${t(criticalContext?.label)} ${t("risk")}`}
            variant="outlined"
            color={getColor()}
            icon={<FiberManualRecordIcon />}
          />
        ) : (
          <Chip
            label={`${t("risk")} ${t(criticalContext?.label)}`}
            variant="outlined"
            color={getColor()}
            icon={<FiberManualRecordIcon />}
          />
        )}{" "}
      </div>
      {/* <DottedLinearProgress color="#ff6d75"></DottedLinearProgress> */}
      {/* <span>
          CardActions are just a flexbox component that wraps the children in
          8px of padding and 8px horizontal padding between children.
        </span> */}
    </Card>
  );
}
